import { Button } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React from 'react';
import { useRowSelectionContext } from '.';

export const renderGridClearSelectionHeader =
  (numRows: number, disabled?: boolean): GridColDef['renderHeader'] =>
  () => {
    const { allSelected, someSelected, clearSelection } = useRowSelectionContext();

    const hide = numRows === 0 || !(someSelected(numRows) || allSelected(numRows));

    return (
      !hide && (
        <Button
          variant="text"
          size="small"
          sx={{ px: 1, py: 0, m: 0, minWidth: 0 }}
          disabled={disabled}
          onClick={clearSelection}
        >
          Clear
        </Button>
      )
    );
  };
